import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/services/api/api.service';
import { IVisitDocument, VisitDocument } from '@precheckin/models/visit-document/visit-document.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VisitDocumentsService {
  private readonly endpoint = `pre-checkin/documents`;

  constructor(private apiService: ApiService) { }

  public getDocumentByVisitId(visitId: string): Observable<IVisitDocument[]> {
    let params = new HttpParams();
    params = params.append(`visitId`, visitId);

    return this.apiService.get<IVisitDocument[]>(this.endpoint, {
      params
    });
  }

  public post(visitDocument: VisitDocument): Observable<IVisitDocument> {
    return this.apiService.post<IVisitDocument>(this.endpoint, visitDocument);
  }

  public put(visitDocument: VisitDocument): Observable<VisitDocument> {
    return this.apiService.put<VisitDocument>(
      `${this.endpoint}/${visitDocument.id}`,
      visitDocument
    );
  }

  public delete(visitDocument: VisitDocument): Observable<object> {
    return this.apiService.delete(
      `${this.endpoint}/${visitDocument.id}/delete`
    );
  }
}
